<template>
  <div class="sxEmblem">
    <sx-icon :size="36" :name="iconName" color="currentcolor" />
  </div>
</template>

<script>
import SxIcon from './SxIcon';

export default {
  components: {
    SxIcon,
  },
  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.sxEmblem {
  align-items: center;
  display: flex;
  justify-content: center;

  height: 80px;
  min-width: 80px;
  width: 80px;

  background: linear-gradient(var(--blue-100), var(--blue-200) 200%);
  border-radius: 100%;
  color: var(--blue-600);
}

.sxEmblem svg {
  color: var(--blue-600);
}
</style>
